import React, { useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import useStyles from "./styles";
import clsx from "clsx";
import { __t } from "@core/translation/translation";
import { menuItems } from "./menuItems";
import Drawer from "@material-ui/core/Drawer";
import { List, ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import Typography from "@components/Typography";
import CustomTooltip from "@components/CustomTooltip";
import { useTheme } from "@material-ui/core";

export default function Sidebar(props) {
  const { menuOver, changeChilde } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const handleDrawer = (value) => {
    setOpen(!open);
  };
  useEffect(() => {
    changeChilde(open);
  }, [open]);

  return !open || menuOver ? (
    <Drawer
      variant="permanent"
      className={clsx(classes.drawer, classes.drawerClose, {
        [classes.drawerOver]: menuOver,
      })}
      classes={{
        paper: clsx(classes.drawerClose),
      }}
    >
      <div>
        <div>
          <Link to={"/"}>
            <div
              className={clsx(classes.logoWrapper, classes.logoWrapperClose)}
            >
              <div className={classes.logoIcon}>
                <img
                  alt={"logo"}
                  height={25}
                  src={
                    theme.palette.type === "light"
                      ? "/static/icons/Logo/Logo-icon.svg"
                      : "/static/icons/Logo/Logo-icon-dark.svg"
                  }
                />
              </div>
              <div className={classes.logoText}>
                <img
                  alt={"logo"}
                  height={12}
                  src={
                    theme.palette.type === "light"
                      ? "/static/icons/Logo/Logo-type.svg"
                      : "/static/icons/Logo/Logo-type-dark.svg"
                  }
                />
              </div>
            </div>
          </Link>
        </div>
        <List>
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={clsx(classes.headerMainMenuButton, {
                showActive: item.component ? false : true,
              })}
            >
              {(item.component && <>{item.component}</>) || (
                <CustomTooltip title={item.title} placement="left">
                  <ListItem
                    className={classes.listItemWrapper}
                    button
                    selected={
                      window.location.pathname === item.path ||
                      item.path.includes(
                        `/${window.location.pathname?.split("/")[1]}/`
                      )
                        ? true
                        : false
                    }
                  >
                    <ListItemIcon>
                      <span
                        className={
                          window.location.pathname === item.path ||
                          item.path.includes(
                            `/${window.location.pathname?.split("/")[1]}/`
                          )
                            ? clsx(
                                item.fiil_icon,
                                classes.icons,
                                classes.selected
                              )
                            : clsx(item.icon, classes.icons)
                        }
                      />
                    </ListItemIcon>
                    <ListItemText
                      secondary={item.title}
                      className={classes.MenuItemsText}
                    />
                  </ListItem>
                </CustomTooltip>
              )}
            </NavLink>
          ))}
        </List>
        {!menuOver && (
          <div
            className={clsx(classes.drawerBottom, classes.drawerBottomClose)}
            onClick={() => handleDrawer()}
          >
            <i
              className={clsx(
                "icon-block-left-collapse",
                classes.drawerBottomIcon
              )}
            ></i>
          </div>
        )}
      </div>
    </Drawer>
  ) : (
    <Drawer
      variant="permanent"
      className={clsx(classes.drawer, classes.drawerOpen, {
        [classes.drawerOver]: menuOver,
      })}
      classes={{
        paper: clsx(classes.drawerOpen),
      }}
    >
      <div>
        <div>
          <Link to={"/"}>
            <div className={clsx(classes.logoWrapper)}>
              <div className={classes.logoIcon}>
                <img
                  alt={"logo"}
                  height={25}
                  src={
                    theme.palette.type === "light"
                      ? "/static/icons/Logo/Logo-icon.svg"
                      : "/static/icons/Logo/Logo-icon-dark.svg"
                  }
                />
              </div>
              <div className={classes.logoText}>
                <img
                  alt={"logo"}
                  height={12}
                  src={
                    theme.palette.type === "light"
                      ? "/static/icons/Logo/Logo-type.svg"
                      : "/static/icons/Logo/Logo-type-dark.svg"
                  }
                />
              </div>
            </div>
          </Link>
        </div>
        <List>
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={clsx(classes.headerMainMenuButton, {
                showActive: item.component ? false : true,
              })}
            >
              {(item.component && <>{item.component}</>) || (
                <>
                  <ListItem
                    className={classes.listItemWrapper}
                    button
                    selected={
                      window.location.pathname === item.path ? true : false
                    }
                  >
                    <ListItemIcon>
                      <span
                        className={
                          window.location.pathname === item.path
                            ? clsx(
                                item.fiil_icon,
                                classes.icons,
                                classes.selected
                              )
                            : clsx(item.icon, classes.icons)
                        }
                      />
                    </ListItemIcon>

                    <ListItemText
                      secondary={item.title}
                      className={classes.MenuItemsText}
                    />
                  </ListItem>
                </>
              )}
            </NavLink>
          ))}
        </List>

        <div
          className={clsx(classes.drawerBottom, classes.drawerBottomOpen)}
          onClick={() => handleDrawer()}
        >
          <Typography variant="sm" color="secondary.tint40">
            {__t("collapse the drawer")}
          </Typography>
          <i
            className={clsx(
              "icon-block-right-collapse",
              classes.drawerBottomIcon
            )}
          ></i>
        </div>
      </div>
    </Drawer>
  );
}
